'use client';

import { Check } from '@mui/icons-material';
import { Menu, MenuItem, ListItemText, ListItemIcon } from '@mui/material';

import { Link, routing, usePathname } from '../../i18n/routing';

import type { ILanguageSelector } from './languageSelector.type';

export const LanguageSelector = ({
  handleClose,
  anchorEl,
  anchorOrigin,
  transformOrigin,
  currentLanguage,
}: ILanguageSelector) => {
  const pathname = usePathname();

  return (
    <Menu
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleClose}
    >
      {routing.locales.map((language) => (
        <Link
          key={language}
          href={pathname}
          locale={language}
          style={{ textDecoration: 'none', color: 'unset' }}
        >
          <MenuItem href={`/${language}`}>
            <ListItemText sx={{ width: '100%' }}>{language.toUpperCase()}</ListItemText>
            {currentLanguage === language && (
              <ListItemIcon sx={{ justifyContent: 'center' }}>
                <Check />
              </ListItemIcon>
            )}
          </MenuItem>
        </Link>
      ))}
    </Menu>
  );
};
